module.exports = __webpack_public_path__ + "static/media/hit-double.96752b36.png";